import type { SVGProps } from 'react';

const base: SVGProps<SVGSVGElement> = {
    viewBox: '0 0 28 28',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.5,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
};

export const Icon = {
    car: (p: SVGProps<SVGSVGElement>) => (
        <svg {...base} {...p}>
            <path d="M5 17v-3.5l2.2-5.2a2 2 0 0 1 1.8-1.3h10a2 2 0 0 1 1.8 1.3L23 13.5V17" />
            <path d="M4 17h20" />
            <circle cx="8.5" cy="18" r="1.8" />
            <circle cx="19.5" cy="18" r="1.8" />
            <path d="M5 17v3M23 17v3" />
        </svg>
    ),
    house: (p: SVGProps<SVGSVGElement>) => (
        <svg {...base} {...p}>
            <path d="M4 12.5 14 4l10 8.5V23a1 1 0 0 1-1 1h-6v-7h-6v7H5a1 1 0 0 1-1-1V12.5Z" />
        </svg>
    ),
    leaf: (p: SVGProps<SVGSVGElement>) => (
        <svg {...base} {...p}>
            <path d="M4 22s2-10 9-14 11-4 11-4 0 8-4 14-10 8-14 6" />
            <path d="M4 22 14 12" />
        </svg>
    ),
    globe: (p: SVGProps<SVGSVGElement>) => (
        <svg {...base} {...p}>
            <circle cx="14" cy="14" r="10" />
            <path d="M4 14h20M14 4c3 3 4.5 6.5 4.5 10S17 21 14 24c-3-3-4.5-6.5-4.5-10S11 7 14 4Z" />
            <circle cx="20" cy="20" r="3" />
            <path d="m22.3 22.3 2 2" />
        </svg>
    ),
    carCrash: (p: SVGProps<SVGSVGElement>) => (
        <svg {...base} {...p}>
            <path d="M5 18v-3.5l2.2-5.2a2 2 0 0 1 1.8-1.3h10a2 2 0 0 1 1.8 1.3L23 14.5V18" />
            <path d="M4 18h20" />
            <circle cx="8.5" cy="19" r="1.8" />
            <circle cx="19.5" cy="19" r="1.8" />
            <path d="m14 4-1.5 4 3-1-1.5 4" />
        </svg>
    ),
} as const;

export type IconKey = keyof typeof Icon;
